import qs from 'qs';
import type { DiscoveryApi, FetchApi } from '@backstage/core-plugin-api';
import { ResponseError } from '@backstage/errors';
import type { SearchApi } from '@backstage/plugin-search-react';
import type { SearchQuery } from '@backstage/plugin-search-common';
import type { SearchSessionTracker } from './searchSession';

/**
 * Search API client that tags every query with `source=ui` and the current
 * search session id (`sid`), so the backend search query log can tell UI
 * searches from API searches and link them to their outcome
 * (`plugins/search-backend-module-ranking`). Otherwise identical to the upstream
 * `SearchClient`.
 */
export class InsightsSearchClient implements SearchApi {
  constructor(
    private readonly options: {
      discoveryApi: DiscoveryApi;
      fetchApi: FetchApi;
      session: SearchSessionTracker;
    },
  ) {}

  async query(query: SearchQuery, options?: { signal?: AbortSignal }) {
    const queryString = qs.stringify({
      ...query,
      source: 'ui',
      sid: this.options.session.current(),
    });
    const baseUrl = await this.options.discoveryApi.getBaseUrl('search');
    const response = await this.options.fetchApi.fetch(
      `${baseUrl}/query?${queryString}`,
      { signal: options?.signal },
    );
    if (!response.ok) {
      throw await ResponseError.fromResponse(response);
    }
    return response.json();
  }
}
